import * as z from 'zod';

import { autoUpdateSettingsSchema } from './auto-update-settings';
import { themeSettingsSchema } from './theme-settings';

export const userSettingsSchema = z.object({
  /**
   * The theme settings of the application.
   */
  theme: themeSettingsSchema.prefault({}),

  /**
   * The auto-update settings of the application.
   */
  autoUpdate: autoUpdateSettingsSchema.prefault({}),
});

export type UserSettings = z.infer<typeof userSettingsSchema>;
